import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import _ from 'lodash'
import Actions from '../../../appFlux/action'
import Paginator from '../../../common/Paginator'

// const genderData = [ // Example Datastructure, Value should be unique, label should be set to display text.
//     { value: 'example1', label: 'Female' },
//     { value: 'example2', label: 'Male' },
//     { value: 'example3', label: 'Others' }
//   ]

class EditMyRefModal extends React.Component {
    constructor(props) {
        super(props);
        var { modal, toggle, references } = props
        this.state = {
            references: _.cloneDeep(references),
            index: references.length > 0 ? 0 : undefined,
        }
    }

    componentWillRecieveProps(props){
        var { modal, toggle, references } = props
        console.log("I AM TRIGGERED.....................")
        this.setState({
            references: _.cloneDeep(references),
            index: references.length > 0 ? 0 : undefined,
        })
    }

    setIndex = (index) => {
        this.setState({ index })
    }

    setReferences = (value, param) => {
        var { references, index } = this.state
        references[index][param] = value
        this.setState({references})
    }

    addReferences = () => {
        var { references, index } = this.state
        var newReference = {
            name: '',
            association: '',
            relation: '',
            email: '',
            phone: ''
        }
        references.push(newReference)
        index = references.length - 1
        this.setState({references, index})
    }

    reset = () => this.setState({references: _.cloneDeep(this.props.references)})
    save = () => {
        Actions.setReferences(this.state.references)
        this.props.toggle()
    }

    render() {
        var { modal, toggle, references } = this.props
        var { references, index } = this.state
        var selectedRef = index !== undefined ? references[index] : undefined
        return (
        <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-850">        
            <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                <div className="modal-header">Edit References</div>
                <div className="v-align f-right" style={{marginLeft:'auto'}}>
                    <i className="fa fa-cog modal-close mg-r-15" ></i> 
                    <i className="far fa-question-circle modal-close mg-r-15" ></i>
                    <i className="fas fa-times modal-close" onClick={toggle}></i>
                </div>
            </div>   
            <hr className="mg-r-0"></hr>
            <div className="modal-block">
                <div className="row mg-b-15">
                    <div className="col-md-6">
                        <div className="modal-subheader">Reference Name</div>
                        <div><input value={selectedRef.name} onChange={(e) => this.setReferences(e.target.value, "name")} type="text" className="form-control"></input></div>
                    </div>
                    <div className="col-md-6">
                        <div className="modal-subheader">Relation</div>
                        <div><input value={selectedRef.relation} onChange={(e) => this.setReferences(e.target.value, "relation")} type="text" className="form-control"></input></div>
                    </div>
                </div>
                <div className="modal-subheader">Associated With</div>                    
                <div className="mg-b-15"><input value={selectedRef.association} onChange={(e) => this.setReferences(e.target.value, "association")} type="text" className="form-control"></input></div>
                <div className="row mg-b-15">
                    <div className="col-md-6">
                        <div className="modal-subheader">e-mail</div>
                        <div><input value={selectedRef.email} onChange={(e) => this.setReferences(e.target.value, "email")} type="text" className="form-control"></input></div>
                    </div>  
                    <div className="col-md-6">
                        <div className="modal-subheader">Phone</div>
                        <div><input value={selectedRef.phone} onChange={(e) => this.setReferences(e.target.value, "phone")} type="text" className="form-control"></input></div>
                    </div>             
                </div>     
            </div>
            <div className="v-align">
                <div className="wd-pct-33">
                    <Paginator index={index} length={references.length} onClick={this.setIndex}/>
                </div>
                <div className="wd-pct-33 text-center">{"Showing " + (index + 1) + " of " + references.length}</div>
                <div style={{marginLeft:'auto'}}>
                    <button className="btn btn-mini btn-default" onClick={this.addReferences}>
                        <i className="fas fa-plus mg-r-5"></i>Add Reference
                        <span className="button-info">3</span>
                    </button>
                </div>
            </div>
            <hr className="mg-0 "></hr>
            <div className="pd-20 box-shadow-top">
                <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>
                <button className="btn btn-primary-lite f-right mg-r-15" onClick={this.save}>Save</button>
                <button className="btn btn-success-lite mg-r-15 f-right" onClick={this.reset}>Reset</button>         
            </div>
        </Modal>
        )
    }
}
export default EditMyRefModal;